import { esperienzaMapMeta } from "../../data/wallCategories";

const HIDDEN_PREFIXES = [
  "/mappa-globale",
  "/esplora-la-mappa",
  "/mappa",
  "/mappa-mondo",
  "/rotta-adriatica",
  "/hub-regionale",
  "/rete-abruzzo",
  "/app",
  "/admin",
];

export function isMapRoutePath(pathname) {
  return HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

function readStoredEsperienza() {
  try {
    return (sessionStorage.getItem("6amico_map_esperienza") || "").trim().toLowerCase();
  } catch {
    return "";
  }
}

/** URL mappa — rispetta esperienza (montagna/terra/mare) e focus comune. */
export function mapQuickAccessHref(pathname, search = "") {
  const params = new URLSearchParams(typeof search === "string" ? search : "");
  const mode = (params.get("mode") || "").toLowerCase();
  const macro = (params.get("macro") || "").toLowerCase();

  if (mode === "mare") return "/esplora-la-mappa?mode=mare";
  if (macro === "montagna") return "/esplora-la-mappa?mode=terra&macro=montagna";
  if (macro === "terra" || mode === "terra") {
    return macro === "montagna"
      ? "/esplora-la-mappa?mode=terra&macro=montagna"
      : "/esplora-la-mappa?mode=terra&macro=terra";
  }

  const espId = readStoredEsperienza();
  const meta = esperienzaMapMeta(espId);
  if (meta?.mapHref) {
    const comuneMatch = pathname.match(/^\/comune\/([^/]+)/);
    if (comuneMatch?.[1] && meta.mapTheme !== "mare") {
      const u = new URL(meta.mapHref, "https://6amico.com");
      u.searchParams.set("comune", comuneMatch[1]);
      return `${u.pathname}${u.search}`;
    }
    return meta.mapHref;
  }

  const comuneMatch = pathname.match(/^\/comune\/([^/]+)/);
  if (comuneMatch?.[1]) {
    return `/esplora-la-mappa?mode=terra&macro=terra&comune=${encodeURIComponent(comuneMatch[1])}`;
  }
  return "/esplora-la-mappa?mode=terra&macro=terra";
}

/** Ex-FAB rimosso — azioni in navbar (HeaderMobileQuickActions). */
export default function MapQuickAccess() {
  return null;
}
